import { MpQuestionSelectContent } from './MpQuestionSelectContent';
export default MpQuestionSelectContent;